import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OverallSetup from "Administrator/commonComponents/GradingSetup/routes/OverallSetup";
import AssessmentCategorySetup from "Administrator/commonComponents/GradingSetup/routes/AssessmentCategorySetup";
import CumulativeScoreSetup from "Administrator/commonComponents/GradingSetup/routes/CumulativeScoreSetup";
import GradeBoundarySetup from "Administrator/commonComponents/GradingSetup/routes/GradeBoundarySetup";
import LocalGradesSetup from "Administrator/commonComponents/GradingSetup/routes/LocalGradeSetup";
import OverallGradeSetup from "Administrator/commonComponents/GradingSetup/routes/OverallGradeSetup";
import AssessmentTypes from "Administrator/commonComponents/GradingSetup/routes/AssessmentTypes";
import Nomenclature from "Administrator/commonComponents/GradingSetup/routes/Nomenclature";
import AggregateSetup from "Administrator/commonComponents/GradingSetup/routes/AggregateSetup";

export default store => ({
  path: "grading-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "module-settings" */ "./components/GradingSetup"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    OverallSetup(store),
    AssessmentCategorySetup(store),
    CumulativeScoreSetup(store),
    GradeBoundarySetup(store),
    LocalGradesSetup(store),
    OverallGradeSetup(store),
    AssessmentTypes(store),
    Nomenclature(store),
    AggregateSetup(store),
  ],
});
